export function changeFont(fontFamily: string) {
  const textElements = document.getElementsByTagName("*");

  // Loop through each text element and update the font-family
  for (let i = 0; i < textElements.length; i++) {
    const element = textElements[i] as HTMLElement;
    element.style.fontFamily = fontFamily;
  }
}
